import { baseURL } from '@/axios'
import fobclient from '@/fobclient'
import { ToastError } from '@/utils'

export const login = ({ dispatch, commit }, data) => {
  commit('LOADING_START')
  return fobclient.login({
    username: data.username,
    password: data.password
  })
    .then(response => dispatch('setupUserSession', response))
}

export const setupUserSession = ({ dispatch, commit }, response) => {
  commit('LOADING_START')

  const error = {
    tomaner: response.status_code != null && response.status_code !== 200,
    fob: response.fob && response.fob.status_code != null && response.fob.status_code !== 200,
    maco: response.maco && response.maco.status_code && response.maco.status_code !== 200
  }

  if (error.tomaner || error.fob) {
    const throwError = {message: `Permission denied`, status: response.status}
    throw throwError
  } else if (error.maco) {
    console.log('error on maco')
    // reset maco login information
    dispatch('tomaner/maco', { loggedIn: false, token: null, expiresAt: null }, { root: true })
    ToastError('Funktionalitäten der Leuris Profilseite im FOB nicht verfügbar.')
  }

  // save and init login on leuris maco
  if (!error.maco && response.maco.body) {
    let vuexMaco = { user: { ...response.maco.body } }
    let selected = response.maco.body.authorisations.find(x => x.fisPersid === response.fob.body.fisPersid)
    if (selected != null) {
      vuexMaco.user.selectedPerson = response.fob.body.fisPersid
      vuexMaco.user.activeRole = selected.type
    }

    dispatch('tomaner/maco', { loggedIn: true, token: vuexMaco.user.token, validUntil: vuexMaco.user.validUntil }, { root: true })
  }

  let orgasWithLinks = []
  let fobResponse = response.fob.body
  if (fobResponse.organisationseinheiten != null) {
    const orgas = fobResponse.organisationseinheiten
    orgasWithLinks = orgas
      .map(orga => {
        return Object.assign(orga, {
          _url: `${baseURL}api/organisationseinheit/${orga._id}`,
          _links: {
            self: {
              href: `${baseURL}api/organisationseinheit/${orga._id}`
            }
          }
        })
      })
      .sort((o1, o2) => {
        if (o1.name > o2.name) {
          return 1
        } else if (o1.name < o2.name) {
          return -1
        } else {
          return 0
        }
      })
  }
  const refinedResponseData = Object.assign(fobResponse, { organisationseinheiten: orgasWithLinks })
  commit('USER_LOGIN', refinedResponseData)
  // })
  dispatch('changeOrga', 0)
  console.log('User logged in successfully.')
  commit('LOADING_DONE')
}

export const logout = ({ commit, dispatch }) => {
  console.log('Logging out.')
  commit('USER_LOGOUT')
  dispatch('aboutme/reset', null, { root: true })
  dispatch('tomaner/reset', null, { root: true })
  // dispatch('list/resetList', null, { root: true })
}

export const changeOrga = ({ state, dispatch, commit }, index) => {
  // only select orga, if user has orgas
  if (state.orgas[index]) {
    commit('CHANGE_ORGA', index)
    dispatch('list/prefillOrga', state.orgas[index], { root: true })
  }
}

export const saveView = ({ state, commit }, viewConfiguration) => {
  commit('SAVE_VIEW', viewConfiguration)
}

export const deleteView = ({ state, commit }, id) => {
  commit('DELETE_VIEW', id)
}

export const activeViewState = ({ state, commit }, id) => {
  commit('ACTIVE_VIEW_STATE', id)
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js